import React from "react";
import {
  TextField,
  makeStyles,
  CardMedia,
  Typography,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
  autocomplete: {
    borderRadius: 10,
    width: 288,
  },
  textfield: {
    margin: "20px auto",
    [`& fieldset`]: {
      borderRadius: 10,
    },
  },
  icon: {
    width: 22,
    height: 22,
  },
  text: {
    marginLeft: 8,
    fontSize: 14,
  },
}));

function CustomerBankSelectField({ options, value, onChange }) {
  const classes = useStyles();
  const translate = useTranslate();
  return (
    <Autocomplete
      classes={{ root: classes.autocomplete }}
      options={options}
      onChange={(_, selectedBank) => {
        onChange(selectedBank);
      }}
      value={value}
      getOptionLabel={(option) => option.name}
      renderOption={(option) => (
        <>
          <CardMedia className={classes.icon} image={option.image_url} />
          <Typography className={classes.text}>{option.name}</Typography>
        </>
      )}
      renderInput={(params) => (
        <TextField
          variant="outlined"
          placeholder={translate("ra.text.paymentMethod.enterBankName")}
          {...params}
        />
      )}
    />
  );
}

export default CustomerBankSelectField;
